import { call, put, takeLatest } from "redux-saga/effects";
import { onGetThemeData, onGetThemeDataError, onGetThemeDataSuccess } from "../Store/Slices/themeSlice";
import { callGetThemeApi } from "../Context/themeApi";

function* GetThemeData({ payload }) {
  try {
    const getThemeResponse = yield call(callGetThemeApi,payload);
    if (getThemeResponse.httpStatusCode === "200") {
      yield put(
        onGetThemeDataSuccess({
          data: getThemeResponse.response,
          message: getThemeResponse.errorMessage,
          status_code:getThemeResponse.httpStatusCode
        })
      );
    } else {
      yield put(
        onGetThemeDataError({
          data: getThemeResponse.response,
          message: getThemeResponse.response.message,
          status_code:getThemeResponse.httpStatusCode
        })
      );
    }
  } catch (error) {
    const message = error.response.data.errorMessage  || "Something went wrong";
    yield put(onGetThemeDataError({ data: [], message, status_code: 400 }));
  }
}
export default function* themeSaga() {
  yield takeLatest(onGetThemeData.type, GetThemeData);
}
